<template>
  <div>
    <div v-if="think" class="think-box">
      <div>
        <i @click="toggleThink" :class="showThink ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
      </div>
      <div class="think-box-content">
        <div class="vertical-line-flex"></div>
        <div v-show="showThink" class="markdown-body" v-html="compiledThinkMarkdown"></div>
      </div>
    </div>
    <div class="markdown-body" v-html="compiledMarkdown"></div>
  </div>
</template>

<script>
import MarkdownIt from "markdown-it";

export default {
  props: {
    source: {
      type: String,
      required: true,
    },
    think: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showThink: true,
    };
  },
  computed: {
    compiledMarkdown() {
      // 初始化 markdown-it 实例
      const md = new MarkdownIt({
        breaks: true, // 启用换行符支持
        html: true, // 启用 HTML 标签支持
        linkify: true, // 自动识别 URL 链接
        typographer: true, // 启用智能标点符号替换
      });
      md.renderer.rules.html_inline = (tokens, idx, options, env, self) => {
        const token = tokens[idx];

        if (token.content.includes("<think>")) {
          return `<p class='think-box'>`;
        }
        if (token.content.includes("</think>")) {
          return `</p>`;
        }
        return self.renderToken(tokens, idx, options);
      };
      // 使用 markdown-it 解析 Markdown 文本
      return md.render(this.source);
    },
    compiledThinkMarkdown() {
      // 初始化 markdown-it 实例
      const md = new MarkdownIt({
        breaks: true, // 启用换行符支持
        html: true, // 启用 HTML 标签支持
        linkify: true, // 自动识别 URL 链接
        typographer: true, // 启用智能标点符号替换
      });
      md.renderer.rules.html_inline = (tokens, idx, options, env, self) => {
        const token = tokens[idx];

        if (token.content.includes("<think>")) {
          return `<p class='think-box'>`;
        }
        if (token.content.includes("</think>")) {
          return `</p>`;
        }
        return self.renderToken(tokens, idx, options);
      };
      // 使用 markdown-it 解析 Markdown 文本
      return md.render(this.think);
    },
  },
  methods: {
    toggleThink() {
      this.showThink = !this.showThink;
    },
  },
};
</script>
<style scoped>
::v-deep ol,
::v-deep ul {
  padding-left: 15px;
}
::v-deep .think-box {
  color: gray;
  font-size: 12px;
}
::v-deep .think-box-content {
  display: flex;
}
::v-deep .think-box-content .vertical-line-flex {
  width: 2px;
  background-color: lightgray;
  margin: 0 5px;
}
::v-deep .markdown-body {
  flex: 1;
}
</style>
